import { withTranslation } from 'react-i18next';
import MonthPicker from './MonthPicker.component';
import I18N_DOMAIN_COMPONENTS from '../../../constants';

export default withTranslation(I18N_DOMAIN_COMPONENTS)(MonthPicker);
